import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";


const initialState = {
    startDate : moment().subtract(14, 'd'),
    endDate: moment().add(1, 'd'),
}

const slice  = createSlice({
    name: 'task',
    initialState,
    reducers: {
        updateStartDate(state, action){
            state.startDate = action.payload;
        },
        updateEndDate(state, action){
            state.endDate = action.payload;
        },
        reset(state){
            state.startDate = moment().subtract(14, 'd');
            state.endDate = moment().add(1, 'd');
        }
    }
});

export const { updateStartDate, updateEndDate} = slice.actions;
export default slice.reducer;

